export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / k ** i) * 100) / 100} ${sizes[i]}`;
};

export const CONNECTORS = [
  { id: 'web-search', name: 'Web Search', icon: '🌐' },
  { id: 'code-interpreter', name: 'Code Interpreter', icon: '💻' },
  { id: 'image-generator', name: 'Image Generator', icon: '🎨' },
  { id: 'data-analyst', name: 'Data Analyst', icon: '📊' },
];
